import React from "react";
import { Eraser } from "lucide-react";
import { Button } from "../../../../shared/components/ui/Button";
import { FormField } from "../../../../shared/components/forms/FormField";

export interface SwimmerFilterProps {
  swimmerName: string;
  onSwimmerNameChange: (value: string) => void;
  onClearFilters: () => void;
}

export const SwimmerFilter: React.FC<SwimmerFilterProps> = ({
  swimmerName,
  onSwimmerNameChange,
  onClearFilters,
}) => {
  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className="flex items-end gap-3 mb-5 max-w-2xl w-full"
    >
      <div className="flex-1">
        <FormField
          type="input"
          label="Nombre"
          inputProps={{
            type: "text",
            placeholder: "Filtrar por nombre",
            value: swimmerName,
            onChange: (e) => onSwimmerNameChange(e.target.value),
          }}
        />
      </div>
      <Button
        type="button"
        onClick={onClearFilters}
        variant="secondary"
        className="h-11 w-11 p-2 flex items-center justify-center shrink-0"
        title="Limpiar filtros"
        aria-label="Limpiar filtros"
      >
        <Eraser  className="shrink-0" />
      </Button>
    </form>
  );
};
